module.exports = __webpack_public_path__ + "static/media/geoportal-8.cc02c80e.png";